import type { FieryRouteQuestionResult } from '../../../../shared/results';
import { FIERY_ROUTE_STARTING_LIVES } from '../domain/routeRules';

export type RoutePhase = 'overview' | 'playing' | 'transitioning' | 'won' | 'lost';

export type RouteGameState = {
  phase: RoutePhase;
  levelIndex: number;
  score: number;
  lives: number;
  streak: number;
  correct: number;
  wrongGates: number;
  caught: number;
  questionResults: FieryRouteQuestionResult[];
};

export function createRouteGameState(): RouteGameState {
  return {
    phase: 'overview',
    levelIndex: 0,
    score: 0,
    lives: FIERY_ROUTE_STARTING_LIVES,
    streak: 0,
    correct: 0,
    wrongGates: 0,
    caught: 0,
    questionResults: [],
  };
}
